import './styles/index.scss';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translation from './translation.json';

i18n.use(initReactI18next).init({
  resources: {
    he: {
      translation,
    },
  },
  lng: process.env.REACT_APP_LANG,
  interpolation: {
    escapeValue: false,
  },
  keySeparator: false,
  nsSeparator: false,
});
